import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Logo from './Logo';
import DesktopNavMenu from './DesktopNavMenu';
import MobileNavMenu from './MobileNavMenu';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  return (
    <>
      <header className={`sticky top-0 z-40 bg-white transition-all duration-300 ${scrolled ? 'shadow-md' : 'border-b border-gray-100'}`}>
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8" aria-label="Global">
          <Link to="/" aria-label="Home" className="shrink-0 flex items-center gap-3">
            <Logo />
            <span className="text-base font-bold text-gray-900 leading-tight">
              Cygnet Call Centre
            </span>
          </Link>

          <DesktopNavMenu />

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+442085385400"
              className="text-sm font-medium text-gray-600 hover:text-cygnet-dark transition-colors"
            >
              0208 538 5400
            </a>
            <Link
              to="/contact"
              className="rounded-md bg-cygnet-dark px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cygnet-DEFAULT transition-colors"
            >
              Get in Touch
            </Link>
          </div>

          <button
            type="button"
            className="lg:hidden -m-2 p-2 rounded-md text-gray-700 hover:text-cygnet-dark hover:bg-gray-50 transition-colors"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="h-6 w-6" />
          </button>
        </nav>
      </header>

      <MobileNavMenu open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </>
  );
};

export default Navbar;
